import {RequestInformationActionDto} from './RequestInformationActionDto';

export class RequestInformationDto {
  "requestInformationActions": RequestInformationActionDto[];
  "personalMessage": string;
  "collaboratorId": string;

  constructor(data: any) {
    this.requestInformationActions = data.requestInformationActions;
    this.personalMessage = data.personalMessage;
    this.collaboratorId = data.collaboratorId;
  }
}
